import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Employee } from 'src/app/_interfaces/employee';
import { TicketDetailPagePage } from 'src/app/_pages/ticket-detail-page/ticket-detail-page.page';
import { AuthService } from 'src/app/_provider/auth.service';
import { DarkmodeService } from 'src/app/_provider/darkmode.service';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { GeneralService } from 'src/app/_provider/general.service';
import { ResizeManagerService } from 'src/app/_provider/resize-manager.service';
import { TicketEditService } from 'src/app/_provider/ticket-edit.service';
import { TicketEmployee} from 'src/app/_provider/tickets/ticket.service';
import { TimeTicketBundle, ZeitenService } from 'src/app/_provider/zeiten.service';

@Component({
    selector: 'app-time-overview-base-item',
    templateUrl: './time-overview-base-item.component.html',
    styleUrls: ['./time-overview-base-item.component.scss'],
    standalone: false
})
export class TimeOverviewBaseItemComponent implements OnInit {

  @Input() public ticketBundle: TimeTicketBundle
  @Input() public show: boolean = true
  @Input() public canOpenTicket: boolean = true
  @Output() timeStoped: EventEmitter<TimeTicketBundle> = new EventEmitter<TimeTicketBundle>(null)

  public now: Date = new Date()

  public employee: Employee

  constructor(
    public timeSrv: ZeitenService,
    private general: GeneralService,
    public ticketEditSrv: TicketEditService,
    private feedback: FeedbackService,
    public authSrv: AuthService,
    private modalCtrl: ModalController,
    private resizeSrv: ResizeManagerService,
    private ticketSrv: TicketEmployee.TicketService
  ) { }

  ngOnInit() {
    this.timeSrv.timer().subscribe(()=>this.now = new Date())
    this.employee = this.ticketEditSrv.employees.find(e => e.id == this.ticketBundle.time.employeeId)
  }

  public async openTicket(){
    if(!this.canOpenTicket) return
    this.general.setActiveTicket(this.ticketBundle.ticket, this.ticketBundle.workspaceId)

    await this.modalCtrl.dismiss()
    if(this.resizeSrv.isPortrait) await this.feedback.openModal(TicketDetailPagePage, {isModal: true, modelWorkstepId: this.ticketBundle.workspaceId})
  }
 
  public async stopTime(){
    this.feedback.vibrate()
    this.ticketBundle.time.taskId = this.ticketBundle.taskId
    this.timeSrv.stopTicketTime(this.ticketBundle.time, this.ticketBundle.ticket, this.ticketBundle.workspaceId)
    this.timeStoped.emit(this.ticketBundle)
  }


}
